<template>
  <div class="max-w-5xl mx-auto mt-5">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>
    <div class="">
      <WidgetInstaller
        v-if="shouldShowWidgetInstaller(config)"
      ></WidgetInstaller>
      <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="renew-headline"
          >
            Whatsapp Chat
          </h3>
          <div class="mt-2 sm:flex sm:items-start sm:justify-between">
            <div class="max-w-xl text-sm leading-5 text-gray-500">
              <p id="renew-description">
                Enable or Disable WhatsApp chat on your store
              </p>
            </div>
            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <VSwitch :value="config.isEnabled" @input="handleSwitch" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="config.isEnabled">
        <div class="chat-settings-layout">
          <div>
            <ChatConfigureForm :config="config" @save="updateConfig" />
            <DesktopSettings :config="config" @save="updateConfig" />
            <MobileSettings :config="config" @save="updateConfig" />
          </div>
          <div class="chat-preview-column">
            <div class="Polaris-LegacyCard mt-4">
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      WhatsApp Button Preview
                    </h2>
                    <div class="Polaris-Tabs__Outer mt-4">
                      <div
                        class="Polaris-Box"
                        style="
                          --pc-box-padding-block-start-md: var(--p-space-200);
                          --pc-box-padding-block-end-md: var(--p-space-200);
                          --pc-box-padding-inline-start-md: var(--p-space-200);
                          --pc-box-padding-inline-end-md: var(--p-space-200);
                        "
                      >
                        <div class="Polaris-Tabs__Wrapper">
                          <div class="Polaris-Tabs__ButtonWrapper">
                            <ul
                              class="Polaris-Tabs"
                              data-tabs-focus-catchment="true"
                              role="tablist"
                            >
                              <li
                                class="Polaris-Tabs__TabContainer"
                                role="presentation"
                              >
                                <button
                                  id="preview-desktop-tab"
                                  :class="[
                                    'Polaris-Tabs__Tab',
                                    {
                                      'Polaris-Tabs__Tab--active':
                                        previewDevice === 'desktop'
                                    }
                                  ]"
                                  role="tab"
                                  type="button"
                                  aria-controls="preview-desktop-panel"
                                  :tabindex="
                                    previewDevice === 'desktop' ? 0 : -1
                                  "
                                  :aria-selected="previewDevice === 'desktop'"
                                  @click="previewDevice = 'desktop'"
                                >
                                  <div
                                    class="Polaris-InlineStack"
                                    style="
                                      --pc-inline-stack-align: center;
                                      --pc-inline-stack-block-align: center;
                                      --pc-inline-stack-wrap: nowrap;
                                      --pc-inline-stack-gap-xs: var(
                                        --p-space-200
                                      );
                                      --pc-inline-stack-flex-direction-xs: row;
                                    "
                                  >
                                    <span
                                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                      >Desktop</span
                                    >
                                  </div>
                                </button>
                              </li>
                              <li
                                class="Polaris-Tabs__TabContainer"
                                role="presentation"
                              >
                                <button
                                  id="preview-mobile-tab"
                                  :class="[
                                    'Polaris-Tabs__Tab',
                                    {
                                      'Polaris-Tabs__Tab--active':
                                        previewDevice === 'mobile'
                                    }
                                  ]"
                                  role="tab"
                                  type="button"
                                  aria-controls="preview-mobile-panel"
                                  :tabindex="
                                    previewDevice === 'mobile' ? 0 : -1
                                  "
                                  :aria-selected="previewDevice === 'mobile'"
                                  @click="previewDevice = 'mobile'"
                                >
                                  <div
                                    class="Polaris-InlineStack"
                                    style="
                                      --pc-inline-stack-align: center;
                                      --pc-inline-stack-block-align: center;
                                      --pc-inline-stack-wrap: nowrap;
                                      --pc-inline-stack-gap-xs: var(
                                        --p-space-200
                                      );
                                      --pc-inline-stack-flex-direction-xs: row;
                                    "
                                  >
                                    <span
                                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                      >Mobile</span
                                    >
                                  </div>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="mt-6 p-4 border rounded bg-gray-50 flex justify-center"
                    >
                      <div
                        id="preview-desktop-panel"
                        v-if="previewDevice === 'desktop'"
                        class="w-full flex justify-center"
                        role="tabpanel"
                        aria-labelledby="preview-desktop-tab"
                        :aria-hidden="previewDevice !== 'desktop'"
                      >
                        <WhatsappButton
                          v-if="previewDevice === 'desktop'"
                          :config="previewConfig"
                        />
                      </div>
                      <div
                        v-if="previewDevice === 'mobile'"
                        id="preview-mobile-panel"
                        class="w-full flex justify-center"
                        role="tabpanel"
                        aria-labelledby="preview-mobile-tab"
                        :aria-hidden="previewDevice !== 'mobile'"
                      >
                        <WhatsappButton
                          v-if="previewDevice === 'mobile'"
                          :config="previewConfig"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <OfficeHours
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <CalloutCard
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <DefaultMessage
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <ChatHideConfig
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />

        <ChatWidget
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
      </div>

      <Notification :text="notificationText" :show="showNotification" />

      <EmbedBlockModal
        v-if="showEmbedModal"
        description="The WhatsApp chat button is not on your theme yet. Add the embed block so it can appear on your storefront."
        @close="showEmbedModal = false"
      />
    </div>
  </div>
</template>

<script>
import VSwitch from "../components/Common/VSwitch";

import ChatConfigureForm from "../components/Common/ChatConfigureForm";
import Notification from "../components/Common/Notification";
import WhatsappButton from "../components/Common/WhatsappButton";

import OfficeHours from "../components/Chat/OfficeHours";
import ChatWidget from "../components/Chat/ChatWidget";
import CalloutCard from "../components/Chat/CalloutCard";
import DefaultMessage from "../components/Chat/DefaultMessage";
import ChatHideConfig from "../components/Chat/ChatHideConfig";
import MobileSettings from "../components/Chat/MobileSettings";
import DesktopSettings from "../components/Chat/DesktopSettings";

import WidgetInstaller from "../components/Chat/WidgetInstaller";
import EmbedBlockModal from "../components/Common/EmbedBlockModal";

import { cloneDeep, isEqual } from "lodash-es";
import crispNudgeMixin from "../Mixins/crispNudgeMixin";

export default {
  name: "Chat",
  mixins: [crispNudgeMixin],
  components: {
    VSwitch,
    ChatConfigureForm,
    Notification,
    WhatsappButton,
    OfficeHours,
    ChatWidget,
    CalloutCard,
    DefaultMessage,
    ChatHideConfig,
    MobileSettings,
    DesktopSettings,
    WidgetInstaller,
    EmbedBlockModal
  },

  data() {
    return {
      config: {},
      originalConfig: {},
      notificationText: "",
      showNotification: false,
      saveBar: null,
      previewDevice: "desktop",
      isConfigLoaded: false,
      showEmbedModal: false
    };
  },
  computed: {
    hasAccessToChatWidget() {
      const store = this.$store.getters.getStore;
      return store.hasAccessToChatWidget;
    },
    previewConfig() {
      const dimensions =
        this.previewDevice === "mobile"
          ? this.config.mobile?.dimensions || this.config.dimensions || {}
          : this.config.dimensions || {};
      return {
        ...this.config,
        dimensions
      };
    }
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },
  created() {
    this.init();
    this.updateOnboadingFlag();
  },
  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },
  methods: {
    async init() {
      const response = await this.$store.dispatch("getChatConfig");
      this.config = response.config;
      this.originalConfig = cloneDeep(response.config);
      this.isConfigLoaded = true;
    },
    checkForChanges() {
      if (!isEqual(this.config, this.originalConfig)) {
        this.saveBar.show();
      } else {
        this.saveBar.hide();
      }
    },
    onSaveBarSaveClicked() {
      this.updateConfig();
      this.saveBar.hide();
    },
    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    },
    updateConfig() {
      console.log(this.config);
      const chatConfig = { ...this.config };
      delete chatConfig.scriptTagId;
      delete chatConfig.isEnabled;
      this.$store
        .dispatch("updateChatConfig", { requestParams: chatConfig })
        .then(() => {
          this.displayNotification("settings updated");
          this.originalConfig = cloneDeep(this.config);
          this.showChatSettingsSavedNudge();
        });
    },
    showChatSettingsSavedNudge() {
      this.showCrispNudge({
        key: "chat_settings_saved",
        text:
          "Chat settings saved! Need help verifying the widget looks right on your store?",
        cooldownMs: 24 * 60 * 60 * 1000,
        scopeToRoute: true
      });
    },
    activateChat() {
      this.$store.dispatch("activateChat").then((response) => {
        if (response.authUrl) {
          if (window.top) {
            window.top.location = response.authUrl;
          } else {
            window.location.href = response.authUrl;
          }
        } else {
          this.config = response.config;
          this.originalConfig = cloneDeep(this.config);
          this.displayNotification("chat enabled");

          if (response.isWidgetInstalled === false) {
            this.showEmbedModal = true;
          }
        }
      });
    },
    deactivateChat() {
      this.$store.dispatch("deactivateChat").then((response) => {
        this.config = response.config;
        this.originalConfig = cloneDeep(this.config);
        this.displayNotification("chat disabled");
      });
    },
    handleSwitch(value) {
      if (value) {
        this.activateChat();
        return;
      }
      this.deactivateChat();
    },
    shouldShowWidgetInstaller(config) {
      if (config && config.createdAt > 1747381243) {
        return true;
      }
      return false;
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isChatPageVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-settings-layout {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
}

.chat-preview-column {
  position: sticky;
  top: 1.5rem;
}
</style>
